import subpic from "../../images/subscribe-form-image.webp";

const HomeSubscribe = () => {
  return (
    <div className="bg-[#FFEBBE] mx-[15px] rounded-[30px] flex flex-col-reverse lg:flex-row items-center justify-evenly mb-[30px] pt-[30px] px-[15px] h-[auto]">
      <img src={subpic} alt="" className="h-[300px] lg:h-[100%]" />
      <div className="mb-[40px] lg:mb-[0]">
        <h3 className="text-[40px] font-[700] text-center">Get Voucher</h3>
        <p className="text-[19px] w-[100%] lg:w-[70%] mb-[20px] text-center">
          Subscribe Today and Unlock Up to <b>20% OFF</b> Your Next Purchase!
        </p>
        <div className="relative">
          <input
            type="email"
            placeholder="Your email address"
            className="pl-[20px] py-[15px] rounded-[5px] w-[100%] lg:w-[75%]"
          />
          <button className="bg-black text-white rounded-[5px] py-[10px] px-[10px] absolute left-[72%] md:left-[83%] lg:left-[58%] top-[12%] hover:bg-amber-500 hover:text-black">
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSubscribe;
